import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".logo-library--O4ZFz {\n  margin: 4.8rem auto 3.2rem auto;\n  width: 236px;\n  height: 152px;\n}";
var styles = {"logo":"logo-library--O4ZFz"};
styleInject(css_248z);

export { styles as default };
